import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

const BetaPill: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="navi-beta-pill">
      <span className="navi-beta-pill__tag">Beta</span>
      <span className="navi-beta-pill__text">{t('CHATBOT_BetaMessage')}</span>
    </div>
  );
};

export default BetaPill;
